import { render } from "./SignalR.vue?vue&type=template&id=237e055d&ts=true"
import script from "./SignalR.ts?vue&type=script&lang=ts&external"
export * from "./SignalR.ts?vue&type=script&lang=ts&external"

import "./SignalR.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__